import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const MemberLogin = () => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      const apiUrl = 'https://naus-backend.onrender.com/api';
      const response = await axios.post(`${apiUrl}/auth/member-login`, {
        email: credentials.email,
        password: credentials.password
      });

      if (response.data && response.data.status === 'success') {
        // Extract session token and member data returned from backend
        const accessToken = response.data.session?.access_token;
        const memberData = response.data.member;

        // Persist tokens across common keys used by auth wrappers / ProtectedRoute
        if (accessToken) {
          localStorage.setItem('token', accessToken);
          localStorage.setItem('memberToken', accessToken);
        }

        if (memberData) {
          localStorage.setItem('member', JSON.stringify(memberData));
          localStorage.setItem('user', JSON.stringify(memberData));
        }

        if (response.data.session) {
          localStorage.setItem('supabase.auth.token', JSON.stringify(response.data.session));
        }

        // Navigate cleanly to member dashboard
        navigate('/member-dashboard');
      }
    } catch (error) {
      if (error.response) {
        setError(error.response.data.message || 'Invalid email or password. Please try again.');
      } else if (error.request) {
        setError('Cannot connect to server. Please check your connection and try again.');
      } else {
        setError('An error occurred. Please try again.');
      }
      console.error('Login error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="section">
      <div className="container">
        <div style={{
          backgroundColor: 'var(--white)',
          padding: '2rem',
          borderRadius: '8px',
          boxShadow: 'var(--shadow)',
          maxWidth: '400px',
          margin: '2rem auto'
        }}>
          <h2 style={{ color: 'var(--primary-green)', textAlign: 'center', marginBottom: '1.5rem' }}>Member Login</h2>
          
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1rem' }}>
              <label htmlFor="email" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={credentials.email}
                onChange={handleChange}
                required
                placeholder="your.email@example.com"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ marginBottom: '0.5rem' }}>
              <label htmlFor="password" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                Password
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                required
                placeholder="Enter your password"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '1rem',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ textAlign: 'right', marginBottom: '1rem' }}>
              <Link
                to="/forgot-password"
                style={{
                  color: 'var(--primary-green)',
                  textDecoration: 'none',
                  fontSize: '0.9rem'
                }}
              >
                Forgot Password?
              </Link>
            </div>

            {error && (
              <div style={{
                backgroundColor: '#f8d7da',
                color: '#721c24',
                padding: '0.75rem',
                borderRadius: '4px',
                marginBottom: '1rem'
              }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={isSubmitting}
              className="btn"
              style={{
                width: '100%',
                padding: '1rem',
                fontSize: '1.1rem',
                cursor: isSubmitting ? 'not-allowed' : 'pointer'
              }}
            >
              {isSubmitting ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginTop: '1rem' }}>
            <p style={{ color: '#666', marginBottom: '0.5rem' }}>
              Don't have an account?
            </p>
            <Link 
              to="/membership" 
              style={{ 
                color: 'var(--primary-green)', 
                textDecoration: 'none',
                fontWeight: 'bold'
              }}
            >
              Create Account
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberLogin;